export { default } from "./ModalQuestion";
export * from "./ModalQuestion";
